import type { LogChunk } from "@shared/types";
import { useEffect, useRef } from "react";

const useLogsScroll = (rawLogs: LogChunk[]) => {
  const logsEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    logsEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [rawLogs]);

  return logsEndRef;
};

export { useLogsScroll };
